import { ChannelData } from '@models/meter-scans/composite/channel-data';
import { SpectrumData } from '@models/meter-scans/composite/spectrum-data';
import { ClassCast } from '@utilities/object-helper';
import { OfdmaScan } from '../ofdma/ofdma-scan';

export class CompositeMeterData {
  mac: string;                             // mac address of the meter used to take the scan
  username: string;                        // User name of the technician who performed the scan
  timestamp: number;                       // Epoch timestamp of the date/ time when the scan was taken
  @ClassCast(ChannelData)
  channelData: ChannelData[] = [];          // Representation of all downstream channels (DOCSIS, Video, VOD, etc)
  @ClassCast(ChannelData)
  upstreamData: ChannelData[] = [];         // Representation of all the DOCSIS upstream channels
  @ClassCast(SpectrumData)
  spectrumBins: SpectrumData[] = [];        // Representation of the full spectrum across all upstream and downstream channels
  @ClassCast(ChannelData)
  downstreamData: ChannelData[] = [];       // Representation of only the DOCSIS downstream channels
  calibration: number;                     // Calibration value set by technician when they ran the scan
  testPointCompensation: null;             // Test points compensation value for scans at nodes and amplifiers
  latitude: number;                        // Latitude location of where the scan was taken
  longitude: number;                       // Longitude location of where the scan was taken
  location: string;                        // Location where the scan was taken (Living Room, Bedroom, etc)
  workOrder: string;                       // Work Order id being worked by technician while the scan was taken
  @ClassCast(OfdmaScan)
  ofdmaData: OfdmaScan[] = [];               // Capture OFDMA data

  /**
   * We do use the empty constructor on MeterData in this application.  Explicitely creating the empty constructor here to call
   * out it's use, even though there is no logic in the function
   */
  constructor() { }

  /**
   * Here we are using a static method to simulate an overloaded constructor requirement.  We initialize MeterData
   * in multiple ways.  Here we pass in a list of parameters we want to use to create a new MeterData object
   *
   * @param username
   * @param timestamp
   * @param channelData
   * @param spectrumBins
   * @param upstreamData
   * @param downstreamData
   * @param calibration
   * @param testPointCompensation
   * @param lat
   * @param lon
   * @param ofdmaData
   */
  static getMeterData(
    username: string,
    timestamp: number,
    channelData: ChannelData[],
    spectrumBins: SpectrumData[],
    upstreamData: ChannelData[],
    downstreamData: ChannelData[],
    calibration: number,
    testPointCompensation: null,
    latitude: number,
    longitude: number,
    ofdmaData: OfdmaScan[]
  ): CompositeMeterData {
    const meterData = new CompositeMeterData();
    meterData.username = username;
    meterData.timestamp = timestamp;
    meterData.channelData = channelData;
    meterData.spectrumBins = spectrumBins;
    meterData.upstreamData = upstreamData;
    meterData.downstreamData = downstreamData;
    meterData.calibration = calibration;
    meterData.testPointCompensation = testPointCompensation;
    meterData.latitude = latitude;
    meterData.longitude = longitude;
    meterData.ofdmaData = ofdmaData;
    return meterData;
  }

}
